<template>
    <v-app v-cloak>
        <v-navigation-drawer :value="!!expandMainMenu && !isDashboardLayoutDisabled" v-show="!isDashboardLayoutDisabled" app mini-variant clipped stateless width="92" mini-variant-width="92"
                             class="no-print sl-nav-rail" :permanent="!$vuetify.breakpoint.mobile && navigationDrawerState && !isDashboardLayoutDisabled">
            <router-link active-class="active" :to="item.route" tag="div"
                         v-for="(item, i) in navDrawerItems" :key="i" @mouseenter.native="setActiveMenu(item)"
                         @mouseleave.native="setActiveMenu(null)"
                         @touchstart.native.stop.prevent="setOrRouteActiveMenu(item)"
                         class="pa-3 text-center caption pointer sl-nav-rail-item">
                <v-icon v-ripple :size="24">{{ item.icon }}</v-icon>
                {{ item.title }}
            </router-link>
        </v-navigation-drawer>

        <v-navigation-drawer
            :value="showSubMenu"
            :permanent="showSubMenu"
            class="fill-viewport no-print"
            fixed
            clipped
            width="300"
            stateless
            @mouseenter.native="onMouseInsideSubmenu(true)"
            @mouseleave.native="onMouseInsideSubmenu(false)"
            style="z-index: 2; min-width: 72px; margin-left: 92px; padding-bottom: 48px; padding-top: 48px;"
        >
            <div class="fill-viewport" @click="setActiveMenu()" v-if="mainSubMenu">
                <v-list rounded>
                    <div v-for="n in mainSubMenu" :key="n.route">
                        <!-- Special divider item -->
                        <v-divider v-if="n.divider"></v-divider>

                        <!-- Spa universe selector -->
                        <div v-else-if="n.spaUniverseMenu">
                            <template v-if="universeEnable && universeEnable.length > 1">
                                <v-menu v-model="dropdownOpen" class="d-block" offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-list-item color="primary" v-on="on">
                                            <v-list-item-avatar>
                                                <v-avatar :color="universe.Color" size="38"><span :class="{'white--text': lightOrDark(universe.Color) !== 'light'}">{{ universe.ShortLabel }}</span></v-avatar>
                                            </v-list-item-avatar>

                                            <v-list-item-title class="pa-0">
                                                <span class="text-caption grey--text">UNIVERS</span><br>
                                                <span class="text-uppercase font-weight-medium">{{universe.Label}}</span>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </template>
                                    <v-list>
                                        <v-list-item v-for="u in universeEnable" :key="u.ID" @click="set_universe(u)" :disabled="universe.ID === u.ID">
                                            <v-list-item-avatar>
                                                <v-avatar :color="u.Color" size="38"><span :class="{'white--text': lightOrDark(u.Color) !== 'light'}">{{ u.ShortLabel }}</span></v-avatar>
                                            </v-list-item-avatar>
                                            <v-list-item-title>{{ u.Label }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                                <v-divider></v-divider>
                            </template>
                        </div>

                        <!-- Subheader item -->
                        <v-sheet v-else-if="n.subheader" class="d-flex align-center"
                                 color="transparent" height="50px">
                            <v-subheader
                                class="overflow-hidden"
                                style="white-space: nowrap">{{ n.subheader }}</v-subheader>
                        </v-sheet>

                        <!-- Regular item -->
                        <v-list-item v-else :to="{ name: n.route, params: n.params }" @click="mouseInsideSubmenu = false" color="secondary">
                            <v-list-item-avatar>
                                <v-icon>{{ n.icon }}</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ n.title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </div>
                </v-list>
            </div>
        </v-navigation-drawer>

        <v-app-bar app class="elevation-0 no-print" style="background: #267CBC" dark flat clipped-left v-if="!isDashboardLayoutDisabled" dense>
            <v-app-bar-nav-icon @click.stop="toggleDrawer" class="hidden-md-and-up" />
            <v-toolbar-title v-html="title" layout="row" layout-align="start center" />

            <v-spacer />

            <v-toolbar-items>
                <v-divider vertical />
                <!-- Voucher scan button -->
                <v-tooltip bottom v-if="hasRight('admin:business:voucher') && !$vuetify.breakpoint.mobile">
                    <template v-slot:activator="{ on }">
                        <v-btn text @click="voucherScanDialog = true" v-on="on">
                            <v-icon>mdi-ticket-percent</v-icon>
                        </v-btn>
                    </template>

                    <span>Scanner un e-billet/bon cadeau</span>
                </v-tooltip>
                <v-divider vertical />

                <!-- VCR -->
                <v-tooltip bottom v-if="hasVcr && !$vuetify.breakpoint.mobile">
                    <template v-slot:activator="{ on }">
                        <v-btn text @click="goToVCR" v-on="on">
                            <v-icon>mdi-cash-register</v-icon>
                        </v-btn>
                    </template>

                    <span>Utiliser la caisse virtuelle</span>
                </v-tooltip>
                <v-divider vertical v-if="hasVcr" />

                <!-- Dims switch button -->
                <v-tooltip bottom v-if="hasDimsBackoffice && !$vuetify.breakpoint.mobile">
                    <template v-slot:activator="{ on }">
                        <v-btn text @click="goToDims" v-on="on">
                            <v-icon>mdi-bug</v-icon>
                        </v-btn>
                    </template>

                    <span>Basculer vers Dims</span>
                </v-tooltip>
                <v-divider vertical v-if="hasDimsBackoffice" />

                <!-- Odeon button -->
                <v-menu v-if="!$vuetify.breakpoint.mobile && authUser && authStatus === 'success'"
                        v-model="odeonPopup.visible"
                        bottom offset-y :close-on-content-click="false" max-width="800px" eager >
                    <template #activator="{ on: onMenu }">
                        <v-tooltip bottom v-on="onMenu">
                            <template v-slot:activator="{ on }">
                                <v-btn text v-on="on" @click="odeonPopup.visible = true">
                                    <v-badge overlap color="red" :content="odeonPopup.unread" :value="odeonPopup.unread !== 0">
                                        <v-icon>mdi-lifebuoy</v-icon>
                                    </v-badge>
                                </v-btn>
                            </template>

                            <span>Aide / Support</span>
                        </v-tooltip>
                    </template>

                    <odeon-popup @unread="onUnreadCount" />
                </v-menu>
                <v-divider vertical />
            </v-toolbar-items>

            <v-menu bottom offset-y v-if="authUser">
                <template v-slot:activator="{ on }">
                    <v-btn text slot="activator" v-on="on">
                        {{ authUser.FirstName }}
                        <span v-if="!$vuetify.breakpoint.mobile">&nbsp; {{ authUser.LastName }}</span>
                        <v-avatar color="teal" class="ml-2" size="32"><span class="white--text">{{ userInitials }}</span></v-avatar>
                    </v-btn>
                </template>

                <v-card>
                    <v-list>
                        <v-list-item :to="{name: 'profil'}">
                            <v-list-item-action><v-icon>mdi-account-details</v-icon></v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Profil</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="logout">
                            <v-list-item-action><v-icon>mdi-logout</v-icon></v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Déconnexion</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>

            <v-divider vertical v-if="wvEnabled()"></v-divider>
            <v-btn text v-if="wvEnabled()" @click="wvClose" style="height: 64px">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-app-bar>

        <v-main>
            <transition name="fade" mode="out-in">
                <forbidden-page v-if="forbidden"></forbidden-page>
                <router-view v-else/>
            </transition>
        </v-main>

        <v-footer v-if="!isDashboardLayoutDisabled" app class="px-3 no-print">
            <div class="text-overline d-flex align-center">
                <a href="https://www.streamlor.io" target="_blank" rel="noopener noreferrer" layout="row" layout-align="center center">
                    <v-img src="/streamlor-h15.png" max-height="15" max-width="20vw" class="mx-2" />
                </a>
                <span class="mx-2">&bull;</span>
                <span>Copyright &copy; 2018-{{ new Date().getFullYear() }}</span>

                <template v-if="!$vuetify.breakpoint.mobile">
                    <span class="mx-2">&bull;</span>
                    <div class="text-overline">Version {{ version }}</div>
                </template>
            </div>
        </v-footer>

        <vue-snotify></vue-snotify>

        <v-dialog v-model="voucherScanDialog" width="1000px">
            <voucher-scan @validated="voucherScanDialog = false"></voucher-scan>
        </v-dialog>
    </v-app>
</template>

<script>
import MainMixin from '@/mixins/main.js'
import WebviewMixin from '~/mixins/webview'
import WsMixin from '~/mixins/ws'
import ApiAuth from '~/api/auth'
import EventBus from '~/eventbus'
import VoucherScan from '~/views/global/VoucherScan.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Consts from 'neptune/consts'
import OdeonPopup from '@/components/odeon/OdeonPopup'
import ForbiddenPage from '@/views/Forbidden.vue'
import _ from 'lodash'

export default {
    components: { ForbiddenPage, OdeonPopup, VoucherScan },

    mixins: [MainMixin, WebviewMixin, WsMixin],

    name: 'App',
    data () {
        return {
            voucherScanDialog: false,
            version: '',
            changelogDialog: false,
            odeonPopup: {
                visible: false,
                unread: 0
            },
            barcode: {
                value: '',
                reading: false
            },
            activeMainMenu: null,
            shouldShowSubMenu: false,
            mouseInsideSubmenu: false,
            universesLoaded: false,
            dropdownOpen: false
        }
    },

    created () {
        // Connect websocket
        this.$connect()
    },

    mounted () {
        this.$store.dispatch('getModules')
        this.$store.dispatch('resetSubscribers')

        if (this.ws_IsConnected && this.authUser) {
            // If we are already connected, send hello directly, otherwise wait for the socket to be open
            this.ws_Authenticate(this.authToken)
        }

        this._ws_Register()
        this.$options.sockets.onopen = () => {
            if (this.authUser) {
                this.ws_Authenticate(this.authToken)
            } else if (this.$route.params && this.$route.params.id) {
                this.ws_AuthenticateByDisplayID(this.$route.params.id)
            }
        }

        this.$options.sockets.onclose = () => {
            this.reconnectWs()
        }

        EventBus.$on('wv-force-route', (route) => {
            if (typeof route === 'object') {
                this.loadWebviewForcedRoute(route.route, route.opts)
            } else {
                this.loadWebviewForcedRoute(route)
            }
        })

        this.$options.sockets.onerror = (err) => {
            console.error('WebSocket error:', err)
            this.reconnectWs()
        }

        // Start the WS KeepAlive ping every 60 seconds
        setInterval(() => {
            this.ws_KeepAlive()
        }, 60000)

        EventBus.$on('toast-message', ({ type, message }) => {
            this.$snotify[type](message)
        })

        if (this.hasRight('admin:lockers') && this.modules.lockers) {
            this.ws_On(
                Consts.WS_RESOURCE_LOCKER_INCIDENTS_NEW,
                this.onNewLockerIncident
            )
        }

        this.ws_On(Consts.WS_RESOURCE_PARAMS, this.onParamsUpdated)

        // barcode scanner
        document.addEventListener('keypress', e => {
            // usually scanners throw an 'Enter' key at the end of read
            if (e.keyCode === 13) {
                if (this.barcode.value.length > 10) {
                    EventBus.$emit('barcode-scanned', this.barcode.value)
                    this.barcode.value = ''
                }
            } else {
                this.barcode.value += e.key // while this is not an 'enter' it stores the every key
            }

            if (!this.barcode.reading) {
                this.barcode.reading = true
                setTimeout(() => {
                    this.barcode.value = ''
                    this.barcode.reading = false
                }, 200)
            }
        })

        if (this.isLoggedIn && !this.wvEnabled()) {
            ApiAuth.checkAuthToken(this.authToken).then(() => {
                this.$store.commit('set_auth_status', 'success')
                this.getGlobalParams()
                if (window.location.pathname === '/') {
                    this.getDefaultRoute().then(route => {
                        this.$router.push({ name: route })
                    })
                }
            })
        }

        // Try for a few seconds to check if we're in a CashRegister WebView. Otherwise, we'll
        // assume we're not in a webview.
        const webViewCheckStart = new Date().getTime()
        const webViewCheck = () => {
            if (this.wvEnabled()) {
                if (this.$route.name !== 'autologin') {
                    this.wvReady()
                }
            } else {
                // Check if we're a webview for up to 3 seconds, otherwise just give up.
                if (new Date().getTime() - webViewCheckStart < 3000) {
                    setTimeout(webViewCheck, 30)
                }
            }
        }

        setTimeout(webViewCheck, 30)

        this.$sysgate.connect()
    },

    destroyed () {
        if (this.hasRight('admin:lockers') && this.modules.lockers) {
            this.ws_Off(
                Consts.WS_RESOURCE_LOCKER_INCIDENTS_NEW,
                this.onNewLockerIncident
            )
        }

        this.ws_Off(Consts.WS_RESOURCE_PARAMS, this.onParamsUpdated)
    },

    watch: {
        authUser: {
            deep: true,
            handler () {
                if (this.ws_IsConnected && !this.ws_IsAuthenticated) {
                    this.ws_Authenticate(this.authToken)
                }
            }
        },

        modules: {
            deep: true,
            handler () {
                if (this.authStatus === 'success' && this.modules.spa && !this.universesLoaded) {
                    this.getUniverses()
                    this.universesLoaded = true
                }
            }
        },

        authStatus (val) {
            if (val === 'success') {
                this.getGlobalParams()
                if (this.modules.spa && !this.universesLoaded) {
                    this.getUniverses()
                    this.universesLoaded = true
                }
            }
        }
    },

    computed: {
        ...mapGetters(['authToken',
                       'authStatus',
                       'authUser',
                       'dimsBackofficeUrl',
                       'forbidden',
                       'hasRight',
                       'isLoggedIn',
                       'modules',
                       'navigationDrawerState',
                       'newIncidentsCounter',
                       'vcrUrl',
                       'expandMainMenu',
                       'universes',
                       'universe'
        ]),

        universeEnable () {
            return this.universes.filter(u => u.State)
        },

        showMenu () {
            return (!this.$vuetify.breakpoint.mobile || this.expandMenu)
        },

        showSubMenu () {
            return (this.shouldShowSubMenu && this.mainSubMenu && this.mainSubMenu.length > 0) || this.mouseInsideSubmenu
        },

        hasDimsBackoffice () {
            return !!this.dimsBackofficeUrl
        },

        hasVcr () {
            return !!this.vcrUrl
        },

        userInitials () {
            return this.authUser.FirstName.substr(0, 1) + this.authUser.LastName.substr(0, 1)
        },

        title () {
            let out = ''
            if (this.$vuetify.breakpoint.mobile) {
                return this.$route.matched.length ? this.$route.matched[this.$route.matched.length - 1].meta.title : ''
            }

            this.$route.matched.forEach((v, idx) => {
                if (idx > 0) {
                    out += ' <i class="mdi mdi-chevron-right mx-2"></i> '
                }
                out += v.meta.title
            })

            return out
        },

        isDashboardLayoutDisabled () {
            return !!this.$route.meta.disableDashboardLayout
        },

        navDrawerItems () {
            const out = []

            if (!this.modules) {
                return out
            }

            if (this.hasRight('admin:planning') && this.modules.planning) {
                out.push({
                    route: { name: 'planning-index' },
                    icon: 'mdi-calendar-month',
                    title: 'Planning',
                    alert: false,
                    hasSubMenu: false
                })
            }
            if (this.hasRight('admin:ctm') && this.modules.ctm) {
                out.push({
                    route: { name: 'turnstiles-index' },
                    icon: 'mdi-turnstile',
                    title: 'Contrôle d\'accès',
                    alert: false,
                    hasSubMenu: true
                })
            }
            if (this.hasRight('admin:clients') && this.modules.clients) {
                out.push({
                    route: { name: 'clients-index' },
                    icon: 'mdi-account-multiple',
                    title: 'Clients',
                    alert: false,
                    hasSubMenu: true
                })
            }
            if (this.hasRight('admin:products') && this.modules.products) {
                out.push({
                    route: { name: 'products-index' },
                    icon: 'mdi-package-variant',
                    title: 'Produits',
                    alert: false,
                    hasSubMenu: true
                })
            }
            if ((this.hasRight('admin:periodic') || this.hasRight('admin:activities')) && this.modules.activities) {
                out.push({
                    route: { name: 'activities-index' },
                    icon: 'mdi-calendar-sync',
                    title: 'Activités',
                    alert: false,
                    hasSubMenu: true
                })
            }
            if (this.hasRight('admin:business') && this.modules.business) {
                let routeName = 'business-index'
                if (this.hasRight('admin:business:export')) {
                    routeName = 'business-exports-financial'
                } else if (this.hasRight('admin:business:voucher')) {
                    routeName = 'business-gift-manager'
                } else if (this.hasRight('admin:business:voucher-sheet')) {
                    routeName = 'business-gift-manager-plancha'
                } else if (this.hasRight('admin:business:discount:template')) {
                    routeName = 'business-discounts-manager-templates'
                } else if (this.hasRight('admin:business:discount:code')) {
                    routeName = 'business-discounts-manager-show'
                }
                out.push({
                    route: { name: routeName },
                    icon: 'mdi-cash-register',
                    title: 'Gestion comm.',
                    alert: false,
                    hasSubMenu: true
                })
            }
            if (this.hasRight('admin:spa') && this.modules.spa) {
                out.push({
                    route: { name: 'spa-index' },
                    icon: 'mdi-spa',
                    title: 'Spa',
                    alert: false,
                    hasSubMenu: true
                })
            }
            if (this.hasRight('admin:stats') && this.modules.stats) {
                out.push({
                    route: { name: 'stats-index' },
                    icon: 'mdi-chart-line',
                    title: 'Stats',
                    alert: false,
                    hasSubMenu: true
                })
            }
            if (this.hasRight('admin:kiosks') && this.modules.kiosks) {
                out.push({
                    route: { name: 'kiosks-index' },
                    icon: 'mdi-television',
                    title: 'Bornes',
                    alert: false,
                    hasSubMenu: false
                })
            }
            if (this.hasRight('admin:lockers') && this.modules.lockers) {
                out.push({
                    route: { name: 'lockers-index' },
                    icon: 'mdi-locker-multiple',
                    title: 'Casiers',
                    alert: this.newIncidentsCounter,
                    hasSubMenu: true
                })
            }
            if (this.hasRight('admin:quotations') && this.modules.quotations) {
                out.push({
                    route: { name: 'quotation-index' },
                    icon: 'mdi-file-sign',
                    title: 'Devis',
                    alert: false,
                    hasSubMenu: true
                })
            }
            if (this.hasRight('admin:displayland') && this.modules.displayland) {
                out.push({
                    route: { name: 'displayland-index' },
                    icon: 'mdi-video-stabilization',
                    title: 'Affichage centralisé',
                    alert: false,
                    hasSubMenu: true
                })
            }
            if (this.hasRight('admin:params')) {
                out.push({
                    route: { name: 'setup' },
                    icon: 'mdi-cog',
                    title: 'Réglages',
                    alert: false,
                    hasSubMenu: true
                })
            }

            return out
        },

        mainSubMenu () {
            if (!this.activeMainMenu) {
                return null
            }

            switch (this.activeMainMenu) {
            case 'setup':
                return this.mainSubMenuSetup
            case 'quotation-index':
                return this.mainSubMenuQuotation
            case 'displayland-index':
                return this.mainSubMenuDisplayland
            case 'stats-index':
                return this.mainSubMenuStats
            case 'spa-index':
                return this.mainSubMenuSpa
            case 'business-exports-financial':
            case 'business-gift-manager':
            case 'business-discounts-manager-templates':
            case 'business-discounts-manager-show':
                return this.mainSubMenuBusiness
            case 'activities-index':
                return this.mainSubMenuActivities
            case 'products-index':
                return this.mainSubMenuProducts
            case 'clients-index':
                return this.mainSubMenuClients
            case 'turnstiles-index':
                return this.mainSubMenuTurnstiles
            }

            return null
        },

        mainSubMenuTurnstiles () {
            const nav = [
                { subheader: 'Général' },
                { title: 'Terminaux', route: 'turnstiles-status', icon: 'mdi-desktop-tower' }
            ]

            if (this.hasRight('admin:ctm:hardware')) {
                nav.push({ title: 'Matériel', route: 'turnstiles-hardware', icon: 'mdi-tablet-cellphone' })
            }

            if (this.hasRight('admin:ctm:planning') || this.hasRight('admin:ctm:area') ||
                this.hasRight('admin:ctm:planning:edit') || this.hasRight('admin:ctm:type-week')) {
                nav.push({ subheader: 'Planning et gestion' })
            }
            if (this.hasRight('admin:ctm:planning')) {
                nav.push({ title: 'Planning d\'accès', route: 'turnstiles-planning', icon: 'mdi-calendar' })
            }
            if (this.hasRight('admin:ctm:area')) {
                nav.push({ title: 'Administration des zones', route: 'turnstiles-area-configuration', icon: 'mdi-floor-plan' })
            }
            if (this.hasRight('admin:ctm:planning:manage')) {
                nav.push({ title: 'Modèles de créneaux', route: 'timeslots-templates', icon: 'mdi-calendar-heart' })
            }
            if (this.hasRight('admin:ctm:type-week')) {
                nav.push({ title: 'Types de semaines', route: 'turnstiles-weeks', icon: 'mdi-calendar-week' })
            }
            if (this.hasRight('admin:ctm:scan') || this.hasRight('admin:ctm:passings') || this.hasRight('admin:ctm:penalty')) {
                nav.push({ subheader: 'Suivi' })
            }
            if (this.hasRight('admin:ctm:scan')) {
                nav.push({ title: 'Scan de billets', route: 'turnstiles-scan', icon: 'mdi-qrcode-scan' })
            }
            if (this.hasRight('admin:ctm:passings')) {
                nav.push({ title: 'Historique de passage', route: 'turnstiles-history', icon: 'mdi-history' })
            }
            if (this.hasRight('admin:ctm:penalty')) {
                nav.push({ title: 'Pénalités', route: 'turnstiles-penalties', icon: 'mdi-timer-outline' })
            }

            return nav
        },

        mainSubMenuClients () {
            const nav = [
                { title: 'Clients', icon: 'mdi-account', route: 'clients-list' }
            ]

            if (this.hasRight('admin:clients:clubs')) {
                nav.push({ subheader: 'Organisations' })
                nav.push({ title: 'Organisations', icon: 'mdi-account-group', route: 'clubs' })
                nav.push({ title: 'Planning', icon: 'mdi-calendar', route: 'planning-clubs' })
                nav.push({ title: 'Facturation', icon: 'mdi-cash-fast', route: 'billing-clubs' })
            }

            return nav
        },

        mainSubMenuProducts () {
            const nav = []

            if (this.hasRight('admin:products')) {
                nav.push({ subheader: 'Produits' })
                nav.push({
                    title: 'Liste des produits',
                    params: { id: 'list' },
                    route: 'products-form',
                    icon: 'mdi-cube-outline'
                })
            }

            if (this.hasRight('admin:products:family-price')) {
                nav.push({
                    title: 'Tarifs et familles',
                    route: 'prices-families',
                    icon: 'mdi-tag'
                })
            }

            if (this.hasRight('admin:products:supplier')) {
                nav.push({ title: 'Fournisseurs', route: 'suppliers', icon: 'mdi-truck' })
            }

            if (this.hasRight('admin:products')) {
                nav.push({
                    title: 'Stocks',
                    route: 'stocks',
                    icon: 'mdi-dolly'
                })
            }

            if (this.hasRight('admin:products:period')) {
                nav.push({
                    title: 'Périodes',
                    route: 'periods',
                    icon: 'mdi-folder-clock'
                })
            }

            if (this.hasRight('admin:products')) {
                nav.push({
                    title: 'Collections',
                    route: 'collections',
                    icon: 'mdi-bookmark-box-multiple'
                })
            }

            return nav
        },

        mainSubMenuActivities () {
            const nav = []

            if (this.hasRight('admin:activities')) {
                nav.push({ subheader: 'Activités' })
                nav.push({
                    title: 'Liste des activités',
                    route: 'activities-form',
                    params: { id: 'list' },
                    icon: 'mdi-swim'
                })
            }

            if (this.hasRight('admin:activities:family')) {
                nav.push({
                    title: "Familles d'activité",
                    route: 'activity-families',
                    icon: 'mdi-group'
                })
            }

            if (this.hasRight('admin:periodic')) {
                nav.push({ subheader: 'Activités périodiques' })
                nav.push({
                    title: 'Sessions périodiques',
                    route: 'sessions',
                    icon: 'mdi-account-box-multiple'
                })
                nav.push({
                    title: 'Inscriptions périodiques',
                    route: 'registrations',
                    icon: 'mdi-clipboard-check-multiple'
                })
                nav.push({
                    title: "Phases d'inscriptions",
                    route: 'phases',
                    icon: 'mdi-calendar-range'
                })
            }

            return nav
        },

        mainSubMenuBusiness () {
            const nav = []

            if (this.modules.business && this.hasRight('admin:business')) {
                if (this.hasRight('admin:business:export')) {
                    nav.push({ subheader: 'Exports' })
                    nav.push({ title: 'Exports financiers', route: 'business-exports-financial', icon: 'mdi-cash-register' })
                    nav.push({ title: 'Exports journaliers', route: 'business-exports-daily', icon: 'mdi-calendar-cursor-outline' })
                }

                if (this.hasRight('admin:business:voucher') || this.hasRight('admin:business:voucher-sheet')) {
                    nav.push({ subheader: 'Coupons et cadeaux' })
                }
                if (this.hasRight('admin:business:voucher')) {
                    nav.push({ title: 'Mes coupons et cadeaux', route: 'business-gift-manager', icon: 'mdi-gift' })
                }
                if (this.hasRight('admin:business:voucher-sheet')) {
                    nav.push({ title: 'Mes planches', route: 'business-gift-manager-plancha', icon: 'mdi-checkerboard' })
                }

                if (this.hasRight('admin:business:discount:template') || this.hasRight('admin:business:discount:code')) {
                    nav.push({ subheader: 'Codes promos' })
                }
                if (this.hasRight('admin:business:discount:template')) {
                    nav.push({ title: 'Modèles de promotions', route: 'business-discounts-manager-templates', icon: 'mdi-sale-outline' })
                }
                if (this.hasRight('admin:business:discount:code')) {
                    nav.push({ title: 'Codes promotionnels', route: 'business-discounts-manager-show', icon: 'mdi-ticket-percent' })
                }
            }

            return nav
        },

        mainSubMenuSpa () {
            const nav = [
                { spaUniverseMenu: true },
                { subheader: 'Planning' },
                { title: 'Planning', route: 'spa-planning', icon: 'mdi-calendar' }
            ]

            if (this.hasRight('admin:spa:manage')) {
                nav.push({ subheader: 'Réglages' })
                nav.push({ title: 'Ressources', route: 'spa-resources', icon: 'mdi-floor-plan' })
                nav.push({ title: 'Personnels', route: 'spa-personnels', icon: 'mdi-account-tie' })
                nav.push({ title: 'Activités', route: 'spa-activities', icon: 'mdi-dumbbell' })
                nav.push({ title: 'Produits', route: 'spa-products', icon: 'mdi-package-variant' })
                nav.push({ title: 'Stocks', route: 'spa-products-stocks', icon: 'mdi-store' })
            }
            return nav
        },

        mainSubMenuStats () {
            const nav = [
                {
                    title: 'Tableau de bord',
                    route: 'stats-dashboard',
                    icon: 'mdi-monitor-dashboard'
                }, {
                    title: 'Fréquentations',
                    route: 'stats-passings',
                    icon: 'mdi-turnstile-outline'
                }, {
                    title: 'Réservations',
                    route: 'stats-activity',
                    icon: 'mdi-swim'
                }, {
                    title: 'Prévisions',
                    route: 'stats-predictions',
                    icon: 'mdi-weather-cloudy-arrow-right'
                }
            ]

            if (this.$store.getters.modules.spa) {
                nav.push({
                    title: 'Spa',
                    route: 'stats-spa',
                    icon: 'mdi-spa'
                })
            }

            return nav
        },

        mainSubMenuDisplayland () {
            const nav = [
                { title: 'Tableau de bord', route: 'displayland-dashboard', icon: 'mdi-view-dashboard' }
            ]
            if (this.hasRight('admin:displayland:manage')) {
                nav.push({ title: 'Gestion des écrans', route: 'displayland-configurations', icon: 'mdi-monitor-multiple' })
            }
            if (this.hasRight('admin:displayland:media')) {
                nav.push({ title: 'Gestion des médias', route: 'displayland-media', icon: 'mdi-multimedia' })
            }

            return nav
        },

        mainSubMenuQuotation () {
            const nav = [
                { title: 'Comptes pro', route: 'quotation-accounts', icon: 'mdi-human-queue' },
                { title: 'Devis', route: 'quotation-quotations', icon: 'mdi-file-document-multiple-outline' },
                { title: 'Bons de commande', route: 'quotation-orders', icon: 'mdi-cart-arrow-down' }
            ]

            if (this.hasRight('admin:quotations:manage')) {
                nav.push({ title: 'Paramètres', route: 'quotation-settings', icon: 'mdi-cog' })
            }

            return nav
        },

        mainSubMenuSetup () {
            const nav = []
            const modules = this.$store.getters.modules

            if (
                this.hasRight('admin:params:settings') ||
                this.hasRight('admin:params:establishments') ||
                this.hasRight('admin:params:mail') ||
                this.hasRight('admin:params:sms') ||
                this.hasRight('admin:params:template') ||
                this.hasRight('admin:params:document')
            ) {
                nav.push({ subheader: 'Plateforme' })
            }
            if (this.hasRight('admin:params:settings')) {
                nav.push({
                    title: 'Paramètres généraux',
                    route: 'setup-main',
                    icon: 'mdi-tune'
                })
            }
            if (this.hasRight('admin:params:establishments')) {
                nav.push({
                    title: 'Établissements',
                    route: 'setup-establishments',
                    icon: 'mdi-domain'
                })
            }
            if (this.hasRight('admin:params:mail')) {
                nav.push({
                    title: 'E-mail',
                    route: 'setup-mailer',
                    icon: 'mdi-email'
                })
            }
            if (this.hasRight('admin:params:sms')) {
                nav.push({
                    title: 'SMS',
                    route: 'setup-smser',
                    icon: 'mdi-cellphone-text'
                })
            }
            if (
                modules.templates_editor &&
                this.hasRight('admin:params:template')
            ) {
                nav.push({
                    title: 'Modèles éditables',
                    route: 'setup-templates',
                    icon: 'mdi-file-document-edit'
                })
            }
            if (this.hasRight('admin:params:document')) {
                nav.push({
                    title: 'Documents',
                    route: 'setup-documents',
                    icon: 'mdi-file-document-multiple'
                })
            }

            if (this.hasRight('admin:params:pricings')) {
                nav.push({ title: 'Tarifications', route: 'setup-pricings', icon: 'mdi-account-cash' })
            }

            if ((modules.spa && this.hasRight('admin:params:spa')) || (modules.planning && this.hasRight('admin:params:planning'))) {
                nav.push(...[{ subheader: 'Planning et réservation' }])
            }

            if (modules.planning && this.hasRight('admin:params:planning')) {
                nav.push({
                    title: 'Planning',
                    route: 'setup-planning',
                    icon: 'mdi-calendar-month'
                })
            }
            if (modules.spa && this.hasRight('admin:params:spa')) {
                nav.push({
                    title: 'Spa',
                    route: 'setup-spa',
                    icon: 'mdi-spa'
                })
            }

            if (modules.stats && this.hasRight('admin:params:stats')) {
                nav.push(
                    { subheader: 'Statistiques' },
                    {
                        title: 'Statistiques',
                        route: 'setup-stats',
                        icon: 'mdi-chart-line'
                    }
                )
            }

            if (modules.ctm) {
                if (
                    this.hasRight('admin:params:ctm') ||
                    this.hasRight('admin:params:area')
                ) {
                    nav.push({ subheader: "Contrôle d'accès" })
                }
                if (this.hasRight('admin:params:ctm')) {
                    nav.push({
                        title: 'Tourniquets',
                        route: 'setup-turnstiles',
                        icon: 'mdi-turnstile'
                    })
                }
                if (this.hasRight('admin:params:area')) {
                    nav.push({
                        title: 'Zones',
                        route: 'setup-areas',
                        icon: 'mdi-floor-plan'
                    })
                }
            }

            if ((modules.cashregister || modules.business) && this.hasRight('admin:params:business')) {
                nav.push(
                    ...[
                        { subheader: 'Gestion commerciale' },
                        {
                            title: 'Export',
                            route: 'setup-exports',
                            icon: 'mdi-cash-register'
                        },
                        {
                            title: 'Bons cadeaux',
                            route: 'setup-vouchers',
                            icon: 'mdi-gift'
                        }
                    ]
                )
            }

            if (modules.lockers && this.hasRight('admin:params:lockers')) {
                nav.push(
                    { subheader: 'Casiers' },
                    {
                        title: 'Général',
                        route: 'setup-lockers-global',
                        icon: 'mdi-earth'
                    },
                    {
                        title: 'Paramètres',
                        route: 'setup-lockers-params',
                        icon: 'mdi-locker'
                    },
                    {
                        title: 'Réservations',
                        route: 'setup-lockers-booking',
                        icon: 'mdi-calendar-check-outline'
                    }
                )
            }

            if (modules.front) {
                nav.push(
                    { subheader: 'Front office' },
                    {
                        title: 'Général',
                        route: 'setup-front-office-general',
                        icon: 'mdi-earth'
                    }
                    // { title: 'Paiements', route: 'setup-front-office-payments', icon: 'mdi-credit-card-outline' }
                )
            }
            if (modules.products) {
                nav.push(
                    { subheader: 'Caisse' },
                    {
                        title: 'TVA',
                        route: 'setup-tva',
                        icon: 'mdi-percent-outline'
                    },
                    {
                        title: 'Modes de prélèvement auto',
                        route: 'setup-auto-debit',
                        icon: 'mdi-credit-card-clock-outline'
                    },
                    {
                        title: 'Bracelet',
                        route: 'setup-wristband',
                        icon: 'mdi-printer-outline'
                    },
                    {
                        title: 'Variantes',
                        route: 'setup-variants',
                        icon: 'mdi-shape'
                    }
                )
            }

            if (this.hasRight('admin:clients') || this.hasRight('admin:clients:clubs')) {
                nav.push({ subheader: 'Organisations' })

                if (this.hasRight('admin:clients')) {
                    nav.push({
                        title: 'Types d\'organisation',
                        route: 'setup-clients-organization-types',
                        icon: 'mdi-domain'
                    })
                }

                if (this.hasRight('admin:clients:clubs')) {
                    nav.push({
                        title: 'Modes de facturation',
                        route: 'setup-clubs-billing-modes',
                        icon: 'mdi-cash'
                    })
                }
            }

            return nav
        }
    },

    methods: {
        ...mapMutations(['setExpandMainMenu', 'set_universe']),
        ...mapActions(['getGlobalParams', 'getUniverses']),

        reconnectWs: _.debounce(function () {
            if (!this.$socket || this.$socket.readyState !== 1) {
                this.$nextTick(() => {
                    this.$connect()

                    setTimeout(() => {
                        // Retry connection after some timeout
                        if (!this.$socket || this.$socket.readyState !== 1) {
                            this.$disconnect()
                        }
                    }, 1000)
                })
            }
        }, 1000),

        logout () {
            this.$store.dispatch('logout').then(() => {
                this.wvLogout()
                this.$router.push({ name: 'login' })
            })
        },

        setOrRouteActiveMenu (item) {
            // Route directly for entries that don't
            if (!item.hasSubMenu) {
                this.$router.push(item.route)
            }

            this.setActiveMenu(item)
        },

        setActiveMenu: _.debounce(function (item) {
            this.activeMainMenu = item ? item.route.name : this.activeMainMenu
            this.shouldShowSubMenu = !!item
        }, 100),

        onMouseInsideSubmenu (inside) {
            if (this.dropdownOpen) {
                return
            }

            this.mouseInsideSubmenu = inside

            if (inside) {
                // this avoid changing the menu contents if we moved quickly over another menu item
                this.setActiveMenu({ route: { name: this.activeMainMenu } })
            } else {
                this.setActiveMenu(null)
            }
        },

        loadWebviewForcedRoute (route, opts = {}) {
            if (this.$route.fullPath !== route) {
                if (opts.forceReload) {
                    window.location.href = route
                } else {
                    this.$router.push(route).then(this.wvReady)
                }
            } else {
                // refresh
                window.location.reload()
            }
        },

        onUnreadCount (unread) {
            this.odeonPopup.unread = unread
        },

        ws_cb_ResponseAuth (res) {
            if (res.Success && this.version && res.Version !== this.version) {
                // Login successful check version
                this.$snotify.confirm('Une mise à jour de l\'interface Streamlor est disponible.', '', {
                    timeout: 0,
                    showProgressBar: false,
                    closeOnClick: false,

                    buttons: [
                        { text: 'Actualiser maintenant', action: () => window.location.reload(), bold: true },
                        { text: 'Plus tard', action: (toast) => { this.$snotify.remove(toast.id) } }
                    ]
                })
            } else {
                this.version = res.Version
            }
        },

        ws_cb_onNotify (payload) {
            EventBus.$emit(payload.Resource, payload.Event)
        },

        goToDims () {
            window.location.href = this.dimsBackofficeUrl + 'admin.php?dims_streamlortoken=' + this.authToken
        },

        onNewLockerIncident () {
            this.$store.dispatch('onNewLockerIncident')
        },

        goToVCR () {
            let urlVCR = ''
            if (this.vcrUrl.startsWith('http://') || this.vcrUrl.startsWith('https://')) {
                urlVCR = this.vcrUrl
            } else {
                urlVCR = 'http://' + this.vcrUrl
            }

            if (!urlVCR.endsWith('/')) {
                urlVCR += '/'
            }

            if (this.authUser && this.authUser.AccountID && this.authUser.ClientAccountID) {
                const infos = {
                    UserID: this.authUser.AccountID,
                    ClientID: this.authUser.ClientAccountID
                }
                ApiAuth.getAuthToken(infos).then(res => {
                    if (res.data && res.data.Token && res.data.Error === 0) {
                        urlVCR += '#/vendeur?authToken=' + res.data.Token
                        window.open(urlVCR, '_blank')
                    }
                })
            } else {
                window.open(urlVCR, '_blank')
            }
        },

        toggleDrawer () {
            // check if there is a sub menu
            if (!this.$vuetify.breakpoint.mobile) {
                this.setExpandMainMenu(this.expandMainMenu === 'mini' ? 'full' : 'mini')
                return
            }

            if ((!EventBus._events['toggle-drawer'] || !EventBus._events['toggle-drawer'].length)) {
                // only manage menu if there is no sub menu
                this.setExpandMainMenu(this.expandMainMenu ? null : 'full')
            } else {
                EventBus.$emit('toggle-drawer', null)
            }
        },

        handleMainMenuClick () {
            if (this.$vuetify.breakpoint.mobile) {
                this.setExpandMainMenu(null)
            }
        },

        onParamsUpdated () {
            this.$store.dispatch('getGlobalParams')
        }
    }
}
</script>

<style>
    .main-nav .v-list-item--active {
        border-right: 3px solid #00639D;
        /*color: #00639D !important;*/
    }

    .sl-nav-rail {
        background-color:#f5f5f5 !important;
    }

    .sl-nav-rail .sl-nav-rail-item {
        min-height: 56px;
        text-align: center;
        hyphens: auto;
        font-size: 10px;
    }

    .sl-nav-rail .sl-nav-rail-item .v-icon {
        width: 56px;
        height: 32px;
        border-radius: 16px;
    }

    .sl-nav-rail .sl-nav-rail-item.active {
        font-weight: bold;
    }

    .sl-nav-rail .sl-nav-rail-item.active .v-icon {
        background: rgba(0, 99, 157,1);
        color:white;
        font-weight: bold;
    }

    .sl-nav-rail .sl-nav-rail-item:hover .v-icon {
        background: rgba(192, 192, 192, 0.4);
    }

    .sl-nav-rail .sl-nav-rail-item.active:hover .v-icon {
        background: rgba(0, 99, 157,0.8);
    }
</style>
